import { Persistent, CadmoOperator, AgaveService } from 'tq-agave';


export type ICompany_Key = { company_id: string;  };

export interface ICompany_Field {
    company_id: string;
    company_name: string;
    city?: string;
    country?: string;
    vat_number?: string;
    imsign_group?: any;
    created_by: any;
    created_on_utc: Date;
    modified_by: any;
    modified_on_utc: Date;
    filter_full?: any;
}

export interface ICompany_Insert {
    company_id?: string;
    company_name: string;
    city?: string;
    country?: string;
    vat_number?: string;
    imsign_group?: any;
    created_by?: any;
    created_on_utc?: Date;
    modified_by?: any;
    modified_on_utc?: Date;
    filter_full?: any;
}

// Persistent automatico per la page RMS_A_company
// Importante! Ogni modifica fatta a questo file sara' persa al prossimo refresh persistent.
// Importante! Non utilizzare direttamente questa classe. Usare invece ../Company
export class Company_BASE extends Persistent<ICompany_Field> {

    static fieldList: string[] = [
        'company_id',
        'company_name',
        'city',
        'country',
        'vat_number',
        'imsign_group',
        'created_by',
        'created_on_utc',
        'modified_by',
        'modified_on_utc',
        'filter_full',
    ];

    static keyList: string[] = [
        'company_id',
    ];

    static updateFieldList: string[] = [
        'company_name',
        'city',
        'country',
        'vat_number',
        'imsign_group',
        'created_by',
        'created_on_utc',
        'modified_by',
        'modified_on_utc',
        'filter_full',
    ];

    company_id?: string;
    company_name?: string;
    city?: string;
    country?: string;
    vat_number?: string;
    imsign_group?: any;
    created_by?: any;
    created_on_utc?: Date;
    modified_by?: any;
    modified_on_utc?: Date;
    filter_full?: any;

    operators: {
        company_id?: CadmoOperator;
        company_name?: CadmoOperator;
        city?: CadmoOperator;
        country?: CadmoOperator;
        vat_number?: CadmoOperator;
        imsign_group?: CadmoOperator;
        created_by?: CadmoOperator;
        created_on_utc?: CadmoOperator;
        modified_by?: CadmoOperator;
        modified_on_utc?: CadmoOperator;
        filter_full?: CadmoOperator;
    } = {};

    constructor(value?: any) {
        super();
        if (value) {
            this.company_id = value['company_id'];
            this.company_name = value['company_name'];
            this.city = value['city'];
            this.country = value['country'];
            this.vat_number = value['vat_number'];
            this.imsign_group = value['imsign_group'];
            this.created_by = value['created_by'];
            this.created_on_utc = AgaveService.getDateFromEpoch(value['created_on_utc']);
            this.modified_by = value['modified_by'];
            this.modified_on_utc = AgaveService.getDateFromEpoch(value['modified_on_utc']);
            this.filter_full = value['filter_full'];
        }
    }

    getPage(): string {
        return 'RMS_A_company';
    }

    getCadmoParams(): any {
        const r: any = {};
        if (this.company_id !== undefined) {
            r.company_id = this.company_id;
        }
        if (this.company_name !== undefined) {
            r.company_name = this.company_name;
        }
        if (this.city !== undefined) {
            r.city = this.city;
        }
        if (this.country !== undefined) {
            r.country = this.country;
        }
        if (this.vat_number !== undefined) {
            r.vat_number = this.vat_number;
        }
        if (this.imsign_group !== undefined) {
            r.imsign_group = this.imsign_group;
        }
        if (this.created_by !== undefined) {
            r.created_by = this.created_by;
        }
        if (this.created_on_utc !== undefined) {
            r.created_on_utc = AgaveService.getEpochFromDate(this.created_on_utc);
        }
        if (this.modified_by !== undefined) {
            r.modified_by = this.modified_by;
        }
        if (this.modified_on_utc !== undefined) {
            r.modified_on_utc = AgaveService.getEpochFromDate(this.modified_on_utc);
        }
        if (this.filter_full !== undefined) {
            r.filter_full = this.filter_full;
        }
        return r;
    }

    getCadmoKeys(): any {
        return {
            company_id: this.company_id,
        };
    }

    getCadmoOperators(): any {
        return {
            _operator_company_id: this.operators.company_id,
            _operator_company_name: this.operators.company_name,
            _operator_city: this.operators.city,
            _operator_country: this.operators.country,
            _operator_vat_number: this.operators.vat_number,
            _operator_imsign_group: this.operators.imsign_group,
            _operator_created_by: this.operators.created_by,
            _operator_created_on_utc: this.operators.created_on_utc,
            _operator_modified_by: this.operators.modified_by,
            _operator_modified_on_utc: this.operators.modified_on_utc,
            _operator_filter_full: this.operators.filter_full,
        };
    }

}

